var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "query-guidelines-content small text-secondary" },
      [
        _c("h5", { staticClass: "text-dark font-weight-bold mb-3" }, [
          _vm._v(" Best Practices for Structuring Search Queries "),
        ]),
        _c("p", { staticClass: "mb-3" }, [
          _vm._v(
            ' To maximize precision and retrieve actionable mechanisms, structure your query around the principles below. The hybrid engine combines exact-match (lexical) and conceptual (semantic) retrieval—clear, entity-aware wording helps you bypass generic "canonical" results and align the graph with your intent. '
          ),
        ]),
        _c(
          "p",
          {
            staticClass:
              "mb-3 small border-left pl-3 query-guidelines-four-checks",
          },
          [
            _c("strong", { staticClass: "text-dark" }, [_vm._v("Four checks")]),
            _vm._v(
              " the extractor uses before suggesting alternate wording: explicit "
            ),
            _c("strong", [_vm._v("anchor")]),
            _vm._v(" (gene, protein, or concrete entity), a "),
            _c("strong", [_vm._v("semantic net")]),
            _vm._v(" (mechanism or pathway concept), "),
            _c("strong", [_vm._v("spatial")]),
            _vm._v(" anchoring (tissue or cell type), and a focused "),
            _c("strong", [_vm._v("phenotypic")]),
            _vm._v(
              " outcome. When all four are satisfied, suggested queries are omitted on purpose. "
            ),
          ]
        ),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v("1. Anchor Your Query with Explicit Targets (Entity Forcing)"),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            ' Purely conceptual searches are prone to the "Canonical Shadow": the system may emphasize historically famous hub genes rather than the specific target you care about. If you are investigating a particular gene or protein, name it explicitly so the engine can anchor topology around that entity (this triggers structured gene targeting in extraction). '
          ),
        ]),
        _c("ul", { staticClass: "mb-3 pl-3" }, [
          _c("li", [
            _c("em", [_vm._v("Suboptimal:")]),
            _vm._v(
              ' "Find a kidney transporter mechanism…" (tends toward heavily annotated, generic transporters).'
            ),
          ]),
          _c("li", [
            _c("em", [_vm._v("Optimal:")]),
            _vm._v(
              ' "Find a kidney transporter mechanism involving SLC22A24…" (anchors the network on your exact target).'
            ),
          ]),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v(
            "2. Define the Anatomical or Cellular Context (Spatial Anchoring)"
          ),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            " Mechanisms are localized. State tissue, cell type, or subcellular compartment to avoid generic systemic hits and keep results tied to your area of interest. "
          ),
        ]),
        _c("ul", { staticClass: "mb-3 pl-3" }, [
          _c("li", [
            _c("em", [_vm._v("Suboptimal:")]),
            _vm._v(' "Find a mechanism for metabolite handling."'),
          ]),
          _c("li", [
            _c("em", [_vm._v("Optimal:")]),
            _vm._v(
              ' "Find a mechanism for metabolite handling in the renal proximal tubule."'
            ),
          ]),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v('3. Limit the Phenotypic Scope and Beware of "Hub Gravity"'),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            ' Broad disease terms (e.g., "heart disease") dilute the search vector—prefer specific traits or biomarkers (e.g., "LDL cholesterol secretion"). Also watch '
          ),
          _c("strong", { staticClass: "text-dark" }, [_vm._v("hub gravity")]),
          _vm._v(
            ": naming a highly pleiotropic hub (e.g., TP53 or SQSTM1) can pull in its most heavily annotated disease contexts and eclipse a narrower question. Prefer the most specific, localized mechanism you can state. "
          ),
        ]),
        _c("ul", { staticClass: "mb-3 pl-3" }, [
          _c("li", [
            _c("em", [_vm._v("Suboptimal:")]),
            _vm._v(
              ' "Find a mechanism that drives blood clotting and heart disease."'
            ),
          ]),
          _c("li", [
            _c("em", [_vm._v("Optimal:")]),
            _vm._v(
              ' "Find a mechanism that alters the hepatic secretion of LDL cholesterol and fibrinogen."'
            ),
          ]),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v('4. Use the "Anchor + Semantic Net" Formula'),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(" Combine an explicit target ("),
          _c("strong", { staticClass: "text-dark" }, [_vm._v("the anchor")]),
          _vm._v(") with a broader biochemical process ("),
          _c("strong", { staticClass: "text-dark" }, [
            _vm._v("the semantic net"),
          ]),
          _vm._v(") without over-constraining the clinical phenotype. "),
        ]),
        _c("p", { staticClass: "mb-2 font-weight-bold text-dark" }, [
          _vm._v(
            ' Suggested template: "Find a [Broad Mechanism / Semantic Net] involving [Explicit Gene Anchor] in [Cell/Tissue Type] that drives [Specific Biomarker/Phenotype]." '
          ),
        ]),
        _c("p", { staticClass: "mb-1 font-weight-bold text-dark small" }, [
          _vm._v("Example of a fully optimized query:"),
        ]),
        _c(
          "blockquote",
          { staticClass: "query-guidelines-example mb-3 pl-3 border-left" },
          [
            _c("em", [
              _vm._v(
                '"Find a mitochondrial metabolic reprogramming mechanism involving the TRAP1 chaperone in vascular smooth muscle cells that drives cellular senescence."'
              ),
            ]),
          ]
        ),
        _c("p", { staticClass: "mb-0 pt-2 border-top" }, [
          _c("strong", { staticClass: "text-dark" }, [
            _vm._v("Why this matters:"),
          ]),
          _vm._v(
            " These patterns teach you how to drive the hybrid pipeline: explicit entities engage exact-match and grounding behavior, while a clear semantic net keeps retrieval interpretable—moving away from generic LLM-style prompts toward queries tuned for this Discovery Engine. "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }